export default __webpack_public_path__ + "static/cc-254721c8cf0633bbd4a4f1b8c4704c09.svg";